/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes, ember/no-get, warp-drive/no-legacy-request-patterns */
import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';
import { alias } from '@ember/object/computed';
import { action, computed } from '@ember/object';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import Scopes from '@linc-technologies/linced-common/enums/scopes';
import { optionAlias } from '@linc-technologies/linced-common/utils/options';
import Jurisdiction from '@linc-technologies/linced-common/enums/jurisdiction';
import DataType from '@linc-technologies/linced-common/enums/data-type';

const automaticDailyCollectionOptionKey =
  'nzMOE:automaticUploads:dailyAttendanceCollection';
const automaticTermlyUploadOptionKey =
  'nzMOE:automaticUploads:termlyAttendanceSurvey';
export default class SchoolOptionsController extends Controller {
  @service
  dates;

  @service
  fetch;

  @service
  options;

  @service
  session;

  @service
  store;

  @service
  strings;

  @alias('session.school')
  school;

  periodDialogOpen = false;
  Scopes = Scopes;
  days = Object.freeze([
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
  ]);
  automaticTermlyUploadOptionKey = automaticTermlyUploadOptionKey;
  automaticDailyCollectionOptionKey = automaticDailyCollectionOptionKey;

  @optionAlias(automaticTermlyUploadOptionKey)
  automaticTermlyUpload;

  @optionAlias(automaticDailyCollectionOptionKey)
  automaticDailyCollection;

  @computed('school.{jurisdiction,yearLevelMap.[]}')
  get canAddRangedSchoolYears() {
    let isInternational = this.school.jurisdiction !== Jurisdiction.NZ_MOE;
    let hasYearLevelsMapped = !isEmpty(this.school.yearLevelMap);
    return isInternational && !hasYearLevelsMapped;
  }

  timeValidation = Object.freeze([
    {
      message: 'Please enter a 24-hour time in HH:MM format',
      validate: (val) => {
        let timePattern = /^\d\d:\d\d$/;
        return timePattern.test(val);
      },
    },
  ]);

  @tracked
  entityFieldIsNew;

  @tracked
  periods;

  initRecord() {
    // Add school address fragments if not present
    if (isEmpty(this.school.physicalAddress)) {
      this.school.set('physicalAddress', this.store.createFragment('address'));
    }
    if (isEmpty(this.school.postalAddress)) {
      this.school.set('postalAddress', this.store.createFragment('address'));
    }
    if (this.school.hasDirtyAttributes) {
      this.school.save();
    }

    // Initialise timetable structure
    this.periods = {
      monday: [],
      tuesday: [],
      wednesday: [],
      thursday: [],
      friday: [],
    };
  }

  getEntityFieldBool(key) {
    let field = this.school.get('fields').get(key);
    if (isEmpty(field)) {
      field = this.createEntityFieldBool(key);
    }
    return field;
  }

  createEntityFieldBool(key) {
    this.school.addField(key, DataType.BOOLEAN);
    this.entityFieldIsNew = true;
    return this.getEntityFieldBool(key);
  }

  @action
  togglePeriodDialog(save) {
    if (this.periodDialogOpen && save) {
      let periods = this.periods;
      let schoolId = this.get('session.school');
      let authorId = this.get('session.person');
      let samePeriods = this.samePeriodsEveryDay;
      let promiseArray = [];
      let days = [];

      this.days.forEach((day, dayIdx) => {
        let sourceDay = day;
        if (samePeriods) {
          sourceDay = 'monday';
        }
        days[dayIdx] = {
          name: day,
          isoDayNumber: dayIdx + 1,
          periodIds: [],
        };
        periods[sourceDay].forEach((p, idx) => {
          let period = this.store.createRecord('timetable/period', {
            schoolId,
            authorId,
            shortName: p.shortName,
            longName: p.longName,
            duration: p.duration,
            startTime: p.startTime,
          });
          promiseArray.push(
            period.save().then((record) => {
              days[dayIdx].periodIds[idx] = record.id;
            }),
          );
        });
      });

      Promise.all(promiseArray).then(() => {
        let structure = this.store.createRecord('timetable/structure', {
          schoolId,
          authorId,
          name: this.structureName,
          effectiveFrom: this.structureEffectiveFrom,
          days,
        });

        structure.save();
      });
    }

    this.toggleProperty('periodDialogOpen');
  }

  @action
  addPeriod(day) {
    this.periods = {
      ...this.periods,
      [day]: [...this.periods[day], {}],
    };
  }

  @action
  removePeriod(period, day) {
    this.periods = {
      ...this.periods,
      [day]: this.periods[day].filter((p) => p !== period),
    };
  }
}
